import axios from 'axios';

const CarouselService = {}

CarouselService.ajouter = (formData, authorization) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/carousel/ajouter`, formData, {
        headers: {
    'Authorization': `Bearer ${authorization}` 
        }
    })

}
export default CarouselService;